module.exports = __webpack_public_path__ + "static/media/media.d4b6fc98.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Epg/media.png
// module id = 2673
// module chunks = 0